import { zodResolver } from "@hookform/resolvers/zod";
import {
    Box,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import BasicDialog from "../../components/base/BasicDialog";
import { useToasts } from "../../hooks/useToasts";
import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { ControlledSelect } from "../../components/form/ControlledSelect/ControlledSelect";

import { useBankById, useUpdateBankMutation } from "../../services/bankingService";

export const bankFormSchema = z
    .object({
        bank_name: z.string().optional().nullable(),
        active: z.boolean().optional().nullable(),
    })

export function UpdateBankDialog(props) {
    const { bankId } = props;
    
    const { data: bankData, isLoading, isFetching } = useBankById(bankId);

    const { handleSubmit, control, formState, register, reset, setValue, watch } = useForm({
        resolver: zodResolver(bankFormSchema),
        defaultValues: {},
    });

    const isFormValid = watch("bank_name")

    const { onFormErrors, onServerError } = useToasts();

    const { mutate: updateBank, isPending } = useUpdateBankMutation({
        onSuccess: () => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyEdited")} />,
                {
                    position: "bottom-right",
                },
            );
            props.onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });


    // Update form values when bank data is loaded
    useEffect(() => {
        if (bankData) {
            reset(bankData)
        }
    }, [bankData, reset]);


    const onSubmit = (data) => {
        updateBank({data:data, id:bankId})
    };   

    if (isFetching || isLoading) {
        return (
            <BasicDialog
                open={props.open}
                onClose={props.onClose}
                titleAlign={"center"}
                contentAlign={"center"}
                title="Loading..."
                maxWidth={"xs"}
                showDialogActions
                alwaysFullScreen={false}
            >
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </BasicDialog>
        );
    }

    return (
            <BasicDialog
                open={props.open}
                onClose={props.onClose}
                titleAlign={"center"}
                contentAlign={"center"}
                showTitle={true}
                title={t("bankings.edit_bank")}
                maxWidth={"sm"}
                
            >
                <Grid container rowSpacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            {...register("bank_name")}
                            fullWidth
                            disabled={false}
                            label={t("bankings.bank_name")}
                            size="small"
                            sx={{background: "white"}}
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <ControlledSelect
                            control={control}
                            name="active"
                            label={`${t("bankings.active")}`}
                            value={watch('active')}
                            data={[{ value: true, label: t("yes") }, { value: false, label: t("no") }]}
                            sx={{textAlign: "left"}}
                            />
                    </Grid>
                    <Grid item xs={12}>
                        <LoadingButton
                            loading={isPending}
                            disabled={!isFormValid || isPending}
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                            onClick={handleSubmit(onSubmit, onFormErrors)}
                            fullWidth
                        >
                            {t("bankings.edit")}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </BasicDialog>
        );
}
